<template>
    <ContainerContent
        class="mb-16"
        outer-container
    >
        <v-row>
            <v-col>
                <h1
                    v-if="title"
                    class="page-title"
                >
                    {{ title }}
                </h1>

                <div
                    v-if="contentMeta.switch"
                    class="text-center text-body-1 mt-2"
                >
                    <NuxtLink :to="contentMeta.switch">Search &amp; Filter Products</NuxtLink>
                </div>
            </v-col>
        </v-row>

        <div
            class="mt-8"
        >
            <LegacyContentItems :items="contentData.sectionData"></LegacyContentItems>
        </div>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import LegacyContentItems from '~/components/content/LegacyContentItems/LegacyContentItems.server.vue';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';
    import type { ContentData, ContentMeta, Page } from '~/types';

    const props = defineProps<{
        contentMeta: ContentMeta
        contentData: Extract<ContentData, Page>
        pageKey: string;
    }>();

    const title = computed<Nilish<string>>(() =>
        props.contentData.header ||
        props.contentData.title ||
        props.contentMeta.seoTitle ||
        props.contentMeta.title
    );
</script>

<style lang="scss" scoped></style>
